import MobileNavigation from '@components/components/Navigation/components/MobileNavigation/MobileNavigation';
import DesktopNavigation from '@components/components/Navigation/components/DesktopNavigation/DesktopNavigation';
import { useMedia } from '@components/hooks';
import { usePageData } from '@components/context';
import React from 'react';

const Navigation = () => {
  const isMobile = useMedia('(max-width: 767px)');
  const {
    hamburgerMenu,
    languageSwitch,
    layoutStructure,
    rootLevel,
    mainMenu,
    metaMenu,
  } = usePageData();

  return isMobile ? (
    <MobileNavigation
      isReduced={false}
      items={hamburgerMenu}
      languageSwitch={languageSwitch}
      logoLink={layoutStructure.logoLink}
      logoLinkDescription={layoutStructure.logoLinkDescription}
      logoType={layoutStructure.logoType}
      metaMenu={metaMenu}
      rootLevel={rootLevel}
    />
  ) : (
    <DesktopNavigation
      languageSwitch={languageSwitch}
      layoutStructure={layoutStructure}
      mainMenu={mainMenu}
      metaMenu={metaMenu}
      rootLevel={rootLevel}
    />
  );
};

export default Navigation;
